import { Injectable } from '@angular/core';
import { ItemResponseWrapper } from 'src/app/shared/http.types';
import { IWhiteLabelDetails } from '../shared/types/white-label.types';

@Injectable({ providedIn: 'root' })
export class WhiteLabelConfigService {
  private readonly _config: IWhiteLabelDetails = {
    id: '',
    hash: '',
    created: '',
  };

  constructor() {
    try {
      const configWrapper = JSON.parse(CONFIG_WL_JSON) as ItemResponseWrapper<IWhiteLabelDetails>;
      if (configWrapper.data) {
        this._config = configWrapper.data;
      } else {
        // eslint-disable-next-line no-console
        console.error('Unexpected WL config', configWrapper);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('WhiteLabelConfig is empty');
    }
  }

  public get config(): IWhiteLabelDetails {
    return this._config;
  }

  public get isWhiteLabelContext(): boolean {
    return !!this.config.id;
  }

  public get logoutRedirectUrl(): string|undefined {
    return this.config.frontendConfigDto?.logoutRedirectUrl;
  }

  public get languageTranslations(): Record<string, any> | null {
    if (this.config.frontendConfigDto?.translations) {
      try {
        return JSON.parse(this.config.frontendConfigDto?.translations) as Record<string, any>;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('WhiteLabelConfig languageTranslations parsing error');
      }
    }

    return null;
  }
}
